import React from 'react';
import { IRequestContext } from '@msdyn365-commerce/core';
export const LoginToViewPricingComponent = (
    context: IRequestContext,
    loginText: string,
    priceComponent: JSX.Element,
    shouldBlockPricing: boolean,
    isZeroPrice: boolean,
    freePriceMask: string,
    className: string = 'login-to-view-pricing'
): JSX.Element => {
    const {
        user: { signInUrl, isAuthenticated }
    } = context;

    if (isAuthenticated) {
        return isZeroPrice ? <span>{freePriceMask}</span> : priceComponent;
    } else if (!isAuthenticated && !shouldBlockPricing) {
        return isZeroPrice ? <span>{freePriceMask}</span> : priceComponent;
    } else {
        return (
            <div className={className}>
                <a href={signInUrl || '#'}>{loginText}</a>
            </div>
        );
    }
};
